import React from "react";
import { ITypographyProps } from "../../@interfaces";



const Text = ({ children, className, ...props }: ITypographyProps) => {
  return (
    <p
      className={`text-[.75rem] font-normal text-gray-700 ${className ?? ""}`}
      {...props}
    >
      {children}
    </p>
  )
}

export default Text;